export default {
  foreignKeyConstraintError: 'Existem registros dependentes',
}
